import React from 'react'
import { connect } from 'react-redux'
import Navbar from 'components/navbar/Navbar'

const Pricing = props => (
  <div className='container-fluid pt-5 px-xl-5 px-3'>
    <h2 className='text-center pricing--h2'>PRICING</h2>
    <div className='container mb-5'>
      <div className='row'>
        <div className='col-md-6'>
          <div className='py-5 px-3' style={{boxShadow: '0 0 5px #ccc', boxSizing: 'content-box'}}>
            <h3 className='text-center'>PACKAGE 1</h3>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='py-5 px-3' style={{boxShadow: '0 0 5px #ccc', boxSizing: 'content-box'}}>
            <h3 className='text-center'>PACKAGE 2</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const mapStateToProps = ( state, props ) => ({

})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing)


// WEBPACK FOOTER //
// ./src/components/landing/Pricing.js